
import { Component, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";

import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();

import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";

import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { IUser } from "@/../../server/src/user/IUser";
import { DeviceSvc } from "@/device/DeviceSvc";
import { IDevice } from "@/device/IDevice";
import ChartVue from "./Chart.vue"



@Component({ components: { FinderVue, ButtonVue, UploaderVue, ChartVue } })
export default class OperatorVue extends Vue {

  _id:string="";
  key=0;

  topic:String=""
  topics:String[]=[]
  program:String="";
  messages:String="";
  is_operator: boolean=false;
  is_admin: boolean=false;

  maszyny: IDevice[]=[];
  maszyna_id:any;
  maszyna:any={};  
  counter:number=0;
  mb:number=0;
  changed=0;
  velocity:number=0;
  counter_topic:string=""
  interval_id:any;
  user_name:string=""
  diameter1:number=-1
  width1:number=-1
  dist1:number=-1
  dist1_topic:string=""
  dist1_gilza_diameter:number=96
  zlecenie="4/12345/2022"
  velocity_mbs=20;
  chart_key=0;
  hours:number=3;
  hours_arr=[1,4,8,24,48]
  licznik=0;
  licznik_key=0

  input1:any[] = []

  rnd(min:number, max:number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  create_data() {
      const data=[]
      let ms = 0
      let timestamp= Date.now()

      for (let i=0;i<100;i++) {
        const d:any={}

        d.ms1 = ms;
        ms+=this.rnd(51000,120000)
        d.ms2=ms;

        d.v1 = this.rnd(0,220)
        d.v2 = d.v1 + this.rnd(0,30)

        d.setup = 1;
        if (d.v2>100) d.setup=0;
        
        d.zlecenie=this.zlecenie
        d.user=this.user_name
        d.maszyna=this.maszyna.idn
        //console.log(this.maszyna)
        d.factor = this.maszyna.counter_faktor;
        d.date=new Date((timestamp+d.ms2)).toISOString();
        

        data.push({ message: JSON.stringify(d)});

      } 
      this.input1 = data;
  }


  created() {
    const millisecondsPerSecond=1000;
    const self=this;
  }

 

  async start_zlecenie() {
        const d:any={}
        d.zlecenie=this.zlecenie
        d.user=this.user_name
        d.maszyna=this.maszyna.idn
        console.log(this.maszyna)
        d.factor = this.maszyna.counter_faktor;
        d.running = 1;
        d.velocity_mbs=this.velocity_mbs;
        d.value=0;
        d.ms=0;
        alert(JSON.stringify(d))

        if (!this.maszyna) return;
        if (!this.maszyna.counter_MAC) return;
        //const topic="/SVR2MCU/TEST_API_KEY/"+this.maszyna.counter_MAC+"/zlecenie"
        if (!this.maszyna!.idn) return;
        const topic=  `/LICZNIK/${this.maszyna.idn}/CONFIG`

        await bus.api('/api/mqtt/publish',{ topic:topic, message: JSON.stringify(d) });
  }

  async stop_zlecenie() {
        const d:any={}
        d.zlecenie=this.zlecenie
        d.user=this.user_name
        d.maszyna=this.maszyna.idn
        d.factor = this.maszyna.counter_faktor;
        d.running = 0;
        d.velocity_mbs=this.velocity_mbs
        d.value=0;
        d.ms=0;
        alert(JSON.stringify(d))

        if (!this.maszyna) return;
        if (!this.maszyna.counter_MAC) return;
        //const topic="/SVR2MCU/TEST_API_KEY/"+this.maszyna.counter_MAC+"/zlecenie"
        if (!this.maszyna!.idn) return;

        const topic=  `/LICZNIK/${this.maszyna.idn}/CONFIG`
        await bus.api('/api/mqtt/publish',{ topic:topic, message: JSON.stringify(d) });

        this.zlecenie=""
        this.velocity_mbs=0;
  }
/*
  async start_ota() {
    if (!this.maszyna) return;
    if (!this.maszyna.counter_MAC) return;
    //const topic="/SVR2MCU/TEST_API_KEY/"+this.maszyna.counter_MAC+"/doota"
    //SVR2MCU/TEST_API_KEY/24:0a:c4:23:be:64/restart
    //let counter_msg = await bus.api('/api/mqtt/publish',{ topic:topic, message: '{"value":0,"ms":0}' });
    if (!this.maszyna!.idn) return;

    const topic=  `/LICZNIK/${this.maszyna.idn}/RESET`
    await bus.api('/api/mqtt/publish',{ topic:topic, message: JSON.stringify(d) });
    this.key++;
  }
*/
  async restart() {
    if (!this.maszyna) return;
    if (!this.maszyna.counter_MAC) return;
    //const topic="/SVR2MCU/TEST_API_KEY/"+this.maszyna.counter_MAC+"/dorestart"
    //SVR2MCU/TEST_API_KEY/24:0a:c4:23:be:64/restart
    const topic=  `/LICZNIK/${this.maszyna.idn}/RESTART`
    let counter_msg = await bus.api('/api/mqtt/publish',{ topic:topic, message: '{}' });

    this.key++;

  }

  async event_licznik(evt:any) {
    console.log(evt.detail.counter)
    
    this.licznik=0
    if (evt.detail.mqtt_topic.indexOf(this.maszyna.idn)>-1) {

      this.licznik=evt.detail.counter
      
      
    }
    this.licznik_key++
  }

  async mounted() {
    console.log('mounted',this.$route.params.prj_id)

    bus.register("/GRAFLOW/LICZNIK/GIDUE_12", this.event_licznik);
    //mc.connect();
    this._id=this.$route.params.prj_id

    const user:IUser=bus.get_user();
    

    if (user.data_grupy.G_ADMIN || user.data_grupy.G_DRUKARZ) {
        this.is_operator=true;
    }

    if (user.data_grupy.G_ADMIN) {
        this.is_admin=true;
    }

    this.user_name=user.data_username;
    
    this.maszyny=<IDevice[]> await new DeviceSvc().get_maszyny();

    this.maszyna_id = window.localStorage.getItem("maszyna_id_for_user_"+user._id);
    for (let i=0;i<this.maszyny.length;i++) {
      if (this.maszyny[i]._id==this.maszyna_id) this.maszyna=this.maszyny[i];
    }
    //await this.get_counter()
    await this.get_sr_roli() 
    window.localStorage.getItem("maszyna",this.maszyna);
    this.create_data();

    
    await this.get_messages();
    const millisecondsPerSecond=1000;
    //this.interval_id = setInterval( async () => {  await await this.get_messages(); }, millisecondsPerSecond*20);

    this.key++;
  }

   beforeDestroy() {
    clearInterval(this.interval_id);
    bus.remove("/GRAFLOW/LICZNIK/GIDUE_12", this.event_licznik);
  }
  
  set_maszyna() {
    if (!this.maszyny) return;
    if (!this.maszyna_id) return;

    for (let i=0;i<this.maszyny.length;i++) {
      if (this.maszyny[i]._id==this.maszyna_id) this.maszyna=this.maszyny[i];
    }
    const user:IUser=bus.get_user();
    if (user) window.localStorage.setItem("maszyna_id_for_user_"+user._id, this.maszyna_id);
    window.localStorage.getItem("maszyna",this.maszyna);
  }


  async get_messages() {

    //if (!this.topic) return;
    const topic="/MCU2SRV/TEST_API_KEY/"+this.maszyna.counter_MAC
    //this.messages=await bus.call('/api/mqtt/get_messages', { maszyna: this.maszyna.idn, zlecenie: this.zlecenie, hours:this.hours})
    this.chart_key++;
   
  }

  async chg() {
    //await this.get_messages();
    this.key++
  }

  async get_counter() {
   
    if (!this.maszyna) return;
    if (!this.maszyna.counter_MAC) return;
    const topic="/MCU2SRV/TEST_API_KEY/"+this.maszyna.counter_MAC
   
    let counter_msg = await bus.api('/api/mqtt/last_message_for_topic',{ topic:topic+"/pcnt"});
     //console.log("A"+counter_msg+"B");
     //counter_msg='{"value":8,"ms":1168640}'
      if (counter_msg) {
        try {
          //console.log(counter_msg)
          //const msg:any=JSON.parse(counter_msg.replace(",",""))
          const msg:any=JSON.parse(counter_msg)
          this.mb = msg.value2;
          this.counter = msg.value2 / msg.factor ;
          this.velocity = msg.v2
          console.log(this.counter)
        } catch (err) {
          this.counter=-1;
          console.log(err)
          }
    }
   
  }

  async get_sr_roli() {
   
    if (!this.maszyna) return;
    if (!this.maszyna.dist1_MAC) return;
    this.dist1_topic="/MCU2SRV/TEST_API_KEY/"+this.maszyna.dist1_MAC+"/distance"
    
    console.log(this.dist1_topic)
    let dist1_msg = await bus.api('/api/mqtt/last_message_for_topic',{ topic:this.dist1_topic});
     //counter_msg='{"value":8,"ms":1168640}'
     console.log(dist1_msg)
      if (dist1_msg) {
        try {
          this.dist1 = JSON.parse(dist1_msg).value ;
          this.width1= Math.round(this.maszyna.dist1_base -  this.dist1 - this.dist1_gilza_diameter/2) ;
          this.diameter1= Math.round((this.maszyna.dist1_base  - this.dist1)*2 ) ;
          console.log(this.dist1, this.diameter1)
        } catch (err) {
          this.diameter1= -1
          this.dist1= -1
           this.width1= -1;
          //console.log(err)
          }
    }
   
  }


}
